import React, { useEffect } from 'react';
import { IItemForGetShortInfo, IGetComboItemsShort, IGetComboItemsShortResponse } from 'types';
import { useFetchData } from 'hooks/useFetchData';
import { getComboItemsShort } from 'backend/comboGroups';
import MultipleSelect from './MultipleSelect';

interface IComboItemsMultipleSelect {
	setComboItems: (value: string[]) => void;
	setFetchedComboItems: (value: IItemForGetShortInfo[]) => void;
	updateComboItems: (value: IItemForGetShortInfo[]) => void;
	selectedRestaurants: string[];
	selectedComboItems: string[];
}

const ComboItemsMultipleSelect: React.FC<IComboItemsMultipleSelect> = ({
	selectedComboItems,
	selectedRestaurants,
	setComboItems,
	setFetchedComboItems,
	updateComboItems,
}) => {
	const { response, loading, refetch, responseError } = useFetchData<
		IGetComboItemsShortResponse,
		IGetComboItemsShort
	>(selectedRestaurants.length ? getComboItemsShort : null, { restaurantIds: selectedRestaurants });

	useEffect(() => {
		if (selectedRestaurants.length) {
			refetch();
		} else {
			updateComboItems([]);
		}
	}, [selectedRestaurants.length]);

	useEffect(() => {
		if (response) {
			setFetchedComboItems(response.data.comboItems);
			updateComboItems(response.data.comboItems);
		}
	}, [response]);

	return (
		<MultipleSelect
			data={response?.data.comboItems || []}
			isLoading={loading}
			refetch={refetch}
			responseError={responseError}
			selectedComboItems={selectedComboItems}
			selectedRestaurants={selectedRestaurants}
			setComboItems={setComboItems}
		/>
	);
};

export default React.memo(ComboItemsMultipleSelect);
